module.exports = __webpack_public_path__ + "static/media/bs.ddf93024.png";